// src/pages/Verify.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE } from "../config/api";

const PROOF_KEY = "ptn_email_proof";
const PROOF_EMAIL = "ptn_proof_email";

const api = axios.create({ baseURL: API_BASE, timeout: 10000 });

export default function Verify() {
  const [state, setState] = useState({ status: "checking", msg: "Verifying your email…" });
  const [proofValue, setProofValue] = useState("");

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token");
    if (!token) {
      setState({ status: "error", msg: "Missing token." });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/verify-email", { token });
        const email = (data?.email || "").toLowerCase();
        const proof = data?.emailProof || "";
        if (!proof) throw new Error("No emailProof returned.");
        localStorage.setItem(PROOF_KEY, proof);
        localStorage.setItem(PROOF_EMAIL, email);
        setProofValue(proof);
        setState({ status: "ok", msg: "Email verified." });
      } catch (e) {
        const msg = e?.response?.data?.error || e?.message || "Verification failed.";
        setState({ status: "error", msg });
      }
    })();
  }, []);

  const goSignup = () => {
    const email = localStorage.getItem(PROOF_EMAIL) || "";
    window.location.replace(`/signup?verified=1&email=${encodeURIComponent(email)}`);
  };

  return (
    <div style={{minHeight:"60vh",display:"grid",placeItems:"center",padding:"24px"}}>
      <div style={{maxWidth:560, width:"100%", background:"#fff", borderRadius:16, padding:24, boxShadow:"0 12px 30px rgba(0,0,0,.08)"}}>
        <h2 style={{margin:"0 0 8px"}}>{state.status === "ok" ? "Email verified ✅" : "Verify email"}</h2>
        <p style={{color:"#475569", marginTop:4}}>{state.msg}</p>

        {state.status === "ok" && (
          <>
            <div style={{marginTop:16, padding:12, background:"#f1f5f9", borderRadius:12, fontFamily:"monospace", wordBreak:"break-all"}}>
              <strong>Verification code (emailProof):</strong><br />
              {proofValue}
            </div>
            <p style={{color:"#64748b", marginTop:8, fontSize:14}}>
              You can finish setup on <strong>this device</strong>, or copy the code to finish on another device.
            </p>
            <div style={{display:"flex", gap:8, marginTop:12, flexWrap:"wrap"}}>
              <button onClick={goSignup} style={{padding:"10px 14px", borderRadius:10, border:"0", background:"#2563eb", color:"#fff", cursor:"pointer"}}>
                Finish setup here
              </button>
              <button
                onClick={() => navigator.clipboard.writeText(proofValue)}
                style={{padding:"10px 14px", borderRadius:10, border:"1px solid #cbd5e1", background:"#fff", color:"#0f172a", cursor:"pointer"}}
              >
                Copy code
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
